import React, { useState } from 'react';
import { useField } from 'formik';
import { Form } from 'react-bootstrap';

import Input from '../Inputs/Input';

import styles from './Search.module.scss';

interface Props {
  name: string;
  placeholder?: string;
  options: string[];

  onChange?: (value: string) => void;
  onFocus?: React.FocusEventHandler;
  onBlur?: React.FocusEventHandler;
}

const Search = ({
  name,
  placeholder,
  options,
  onChange,
  onFocus,
  onBlur,
}: Props) => {
  const [field, meta, helpers] = useField(name);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const { value } = field;
  const { setValue } = helpers;

  const filteredOptions = options
    .filter((option) => new RegExp(value, 'i').test(option))
    .slice(0, 5);

  const handleInputChange = (newValue: string) => {
    onChange?.(newValue);
    setValue(newValue ?? '');
  };

  const isInvalid = Boolean(meta.error);

  return (
    <div onFocus={onFocus} onBlur={onBlur}>
      <Form.Group>
        <Input
          name={name}
          value={value}
          placeholder={placeholder}
          className={isInvalid ? 'is-invalid' : ''}
          onFocus={() => setShowOptions(true)}
          onBlur={() => setShowOptions(false)}
          onChange={handleInputChange}
          autoComplete="off"
        />

        <div
          className={styles.select__dropdown}
          style={{ visibility: showOptions ? 'visible' : 'hidden' }}
        >
          {filteredOptions.map((option, index) => {
            let className = styles.select__dropdown_option;
            if (index === selectedIndex) {
              className += ` ${styles.select__dropdown_option__selected}`;
            }

            return (
              <div
                key={option}
                role="presentation"
                className={className}
                onMouseEnter={() => setSelectedIndex(index)}
                onMouseDown={(event) => {
                  event.stopPropagation();
                  setValue(option);
                }}
              >
                {option}
              </div>
            );
          })}
        </div>

        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
          {meta.error ?? ' '}&nbsp;
        </Form.Control.Feedback>
      </Form.Group>
    </div>
  );
};

Search.defaultProps = {
  placeholder: '',
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
};

export default Search;
